module.exports = __webpack_public_path__ + "static/img/qi_12.a43cdce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qi_12.jpg
// module id = 2M/i
// module chunks = 1